import { useState, useEffect, useContext } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { TextField } from '@mui/material';
import { OpenSwal, notistackSnakebar } from '../../Utils';
import { useNavigate } from 'react-router-dom';
import { LoadingButton } from '@mui/lab';
import { useSnackbar } from 'notistack';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import Paper from '@mui/material/Paper';
import EditCalendarOutlinedIcon from '@mui/icons-material/EditCalendarOutlined';
import LinearProgress from '@mui/material/LinearProgress';
import Autocomplete from '@mui/material/Autocomplete';
import UploadOutlinedIcon from '@mui/icons-material/UploadOutlined';
import { url_list_get_by_status, url_update_countrycode_timezone } from '../../RoutesMap';
import { TextUnderlineHeading } from '../../Styles';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import LoginIcon from '@mui/icons-material/Login';
import { apiWithAuth } from '../../Services/Axios/axios';
import { AuthContext } from '../../Context/AuthProvider';
import { LockOpen } from '@mui/icons-material';



dayjs.extend(utc)
dayjs.extend(timezone)

export default function AppSetting() {
  const { currentUser } = useContext(AuthContext);
  const appThemeColor = "#" + process.env.REACT_APP_THEME_COLOR;
  const appThemeSecondaryColor = process.env.REACT_APP_THEME_SECONDARY_COLOR;
  const navigate = useNavigate();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [AccordianTimeZoneStatus, setAccordianTimeZoneStatus] = useState(false);
  const [CountryOptions, setCountryOptions] = useState([]);
  const [CountrySelectBoxValue, setCountrySelectBoxValue] = useState(null);
  const [CountrySelectBoxLoadingStatus, setCountrySelectBoxLoadingStatus] = useState(false);
  const [TimezoneOptions, setTimezoneOptions] = useState([]);
  const [TimezoneSelectBoxValue, setTimezoneSelectBoxValue] = useState(null);
  const [TimezoneSelectBoxLoadingStatus, setTimezoneSelectBoxLoadingStatus] = useState(false);
  const [TimeZoneUpdateButtonLoadingStatus, setTimeZoneUpdateButtonLoadingStatus] = useState(false);
  const [TimezoneSettingErrorMessages, setTimezoneSettingErrorMessages] = useState({});
  const [CurrentDateTimeValue, setCurrentDateTimeValue] = useState({});
  // const [TimezoneSelectBoxLoadingStatus, setTimezoneSelectBoxLoadingStatus] = useState(false);

  useEffect(() => {
    if (AccordianTimeZoneStatus) {
      setCountrySelectBoxLoadingStatus(true);
      setTimezoneSelectBoxLoadingStatus(true);

      let payload = {
        status: 'get_contries_timezone_list'
      };
      apiWithAuth.post(url_list_get_by_status, payload, { headers: { "Content-Type": "multipart/form-data" } }).then(response => {
        if (response.data.status) {
          setCountryOptions(response.data.country_lists);
          setCountrySelectBoxValue(response.data.default_country);
          setTimezoneOptions(response.data.timezone_lists);
          setTimezoneSelectBoxValue(response.data.default_timezone);
          if (response.data.country_lists.length > 0) {
            setCountrySelectBoxLoadingStatus(false);
          }
          if (response.data.country_lists.length > 0) {
            setTimezoneSelectBoxLoadingStatus(false);
          }
        } else if (response.data.status === false && response.data.message === "Token Expired") {
          OpenSwal('Token_error', navigate);
        } else {
          OpenSwal('Axios_error', response.data.message);
        }
      }).catch(response => {
        OpenSwal('Axios_error', response.message);
      });
    } else {
      setCurrentDateTimeValue({ utc_time: dayjs.tz(new Date(), "UTC").format('MM/DD/YYYY hh:mm A'), user_time: dayjs.tz(new Date(), currentUser['custom:user_timezone']).format('MM/DD/YYYY hh:mm A') });
    }

  }, [AccordianTimeZoneStatus]);


  const getTimezoneListbyCountryCode = (newValue) => {
    setCountrySelectBoxValue(newValue);
    setCurrentDateTimeValue({ utc_time: null, user_time: null });
    setTimezoneSettingErrorMessages({});
    if (newValue) {
      setTimezoneSelectBoxLoadingStatus(true);
      let payload = {
        status: 'get_contries_timezone_list',
        country_code: newValue.country_code
      };
      apiWithAuth.post(url_list_get_by_status, payload, { headers: { "Content-Type": "multipart/form-data" } }).then(response => {
        if (response.data.status) {
          setTimezoneOptions(response.data.timezone_lists);
          setTimezoneSelectBoxValue(null);
          if (response.data.country_lists.length > 0) {
            setTimezoneSelectBoxLoadingStatus(false);
          }
        } else if (response.data.status === false && response.data.message === "Token Expired") {
          OpenSwal('Token_error', navigate);
        } else {
          OpenSwal('Axios_error', response.data.message);
        }
      }).catch(response => {
        OpenSwal('Axios_error', response.message);
      });
    } else {
      setTimezoneOptions([]);
      setTimezoneSelectBoxValue(null);
    }
  }
  const SetCurrentDateTimeStateValue = (newValue) => {
    setTimezoneSelectBoxValue(newValue);
    setTimezoneSettingErrorMessages({});
    if (newValue) {
      setCurrentDateTimeValue({ utc_time: dayjs.tz(new Date(), "UTC").format('MM/DD/YYYY hh:mm A'), user_time: dayjs.tz(new Date(), newValue.timezone_name).format('MM/DD/YYYY hh:mm A') });
    } else {
      setCurrentDateTimeValue({ utc_time: null, user_time: null });
    }
  }

  const NavigateSettingPage = (page_name) => {
    if (page_name === 'vacation')
      navigate('/Interpreter/Vacation_Setting');
    else if (page_name === 'view_profile')
      navigate('/Interpreter/Update_profile');
    else if (page_name === 'update_profile') {
      let url = process.env.REACT_APP_IAM_PORTAL_URL + '/update-profile?portal=' + window.location.origin + window.location.pathname + '&sub=' + currentUser?.sub + '&user_type=talent';
      window.location.href = url;
    }
    else if (page_name === 'change_password') {
      let url = process.env.REACT_APP_IAM_PORTAL_URL + '/change-password?portal=' + window.location.origin + window.location.pathname + '&sub=' + currentUser?.sub + '&user_type=talent';
      window.location.href = url;
    }
    else if (page_name === 'verify_logins') {
      let url = process.env.REACT_APP_IAM_PORTAL_URL + '/verify-logins?portal=' + window.location.origin + window.location.pathname + '&sub=' + currentUser?.sub + '&user_type=talent';
      window.location.href = url;
    }
  };


  return (
    <Box>
      <Box sx={{ mb: 6 }}>
        <Box>
          <Typography sx={{ typography: { xs: 'subtitle2', sm: 'body1', md: 'h6' } }} color={appThemeColor} style={TextUnderlineHeading} >General Settings</Typography>
        </Box>

        <Box mt={3}>
          <Box>
            <Paper sx={{ backgroundColor: '#D9D9D9', borderRadius: 1, minHeight: 48, paddingRight: 2, paddingLeft: 2, display: 'flex', alignItems: 'center', cursor: 'pointer' }} elevation={1} onClick={() => NavigateSettingPage('update_profile')}>
              <AccessTimeIcon fontSize='small' sx={{ mr: 0.5, color: appThemeColor }} />
              <Typography color={appThemeColor} sx={{ flexGrow: 1 }}>Update Timezones</Typography>
              <KeyboardArrowRightIcon color={appThemeSecondaryColor} />
            </Paper>
          </Box>

          <Box mt={2}>
            <Paper sx={{ backgroundColor: '#D9D9D9', borderRadius: 1, minHeight: 48, paddingRight: 2, paddingLeft: 2, display: 'flex', alignItems: 'center', cursor: 'pointer' }} elevation={1} onClick={() => NavigateSettingPage('change_password')}>
              <LockOpen fontSize='small' sx={{ mr: 0.5, color: appThemeColor }} />
              <Typography color={appThemeColor} sx={{ flexGrow: 1 }}>Change Password</Typography>
              <KeyboardArrowRightIcon color={appThemeSecondaryColor} />
            </Paper>
          </Box>

          <Box mt={2}>
            <Paper sx={{ backgroundColor: '#D9D9D9', borderRadius: 1, minHeight: 48, paddingRight: 2, paddingLeft: 2, display: 'flex', alignItems: 'center', cursor: 'pointer' }} elevation={1} onClick={() => NavigateSettingPage('vacation')}>
              <EditCalendarOutlinedIcon fontSize='small' sx={{ mr: 0.5, color: appThemeColor }} />
              <Typography color={appThemeColor} sx={{ flexGrow: 1 }}>Vacation Settings</Typography>
              <KeyboardArrowRightIcon color={appThemeSecondaryColor} />
            </Paper>
          </Box>

          <Box mt={2}>
            <Paper sx={{ backgroundColor: '#D9D9D9', borderRadius: 1, minHeight: 48, paddingRight: 2, paddingLeft: 2, display: 'flex', alignItems: 'center', cursor: 'pointer' }} elevation={1} onClick={() => NavigateSettingPage('view_profile')}>
              <VisibilityOutlinedIcon fontSize='small' sx={{ mr: 0.5, color: appThemeColor }} />
              <Typography color={appThemeColor} sx={{ flexGrow: 1 }}>View Interpreter Profile</Typography>
              <KeyboardArrowRightIcon color={appThemeSecondaryColor} />
            </Paper>
          </Box>

          <Box mt={2}>
            <Paper sx={{ backgroundColor: '#D9D9D9', borderRadius: 1, minHeight: 48, paddingRight: 2, paddingLeft: 2, display: 'flex', alignItems: 'center', cursor: 'pointer' }} elevation={1} onClick={() => NavigateSettingPage('verify_logins')}>
              <LoginIcon fontSize='small' sx={{ mr: 0.5, color: appThemeColor }} />
              <Typography color={appThemeColor} sx={{ flexGrow: 1 }}>Verify Logins</Typography>
              <KeyboardArrowRightIcon color={appThemeSecondaryColor} />
            </Paper>
          </Box>
        </Box>
      </Box>
    </Box >
  )
}

